import React from 'react';
import { ErrorState } from './States';

/**
 * Catches render-time errors so one bad API payload shows a recoverable
 * message instead of unmounting the whole app into a blank white page.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.error('Unhandled render error:', error, info);
    }
  }

  componentDidUpdate(prevProps) {
    // Recover automatically when the user navigates elsewhere.
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorState
          title="This page ran into a problem"
          description="Please refresh, or head back to the homepage."
          onRetry={() => window.location.reload()}
        />
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
